<template>
  <iColumn>
    <iColumn gap="none">
      <iText>
        Link Text
      </iText>
      <iTextInput
        v-model="internalLinkText"
        size="small"
        width="fill"
      />
    </iColumn>
    <iColumn gap="none">
      <iText>
        Link Type
      </iText>
      <iSelect
        size="small"
        value-field="id"
        width="fill"
        :style-overrides="{
          inputBackgroundColor: 'paper',
        }"
        label-field="name"
        :model-value="internalLinkType"
        :items="LinkType.options"
        return-value
        @update:model-value="internalLinkType = $event"
      />
    </iColumn>
    <iColumn gap="none">
      <iText>
        Value
      </iText>
      <StudioAutoComplete
        v-if="internalLinkType === LinkType.LINK_TYPE_PAGE"
        :model-value="internalLinkValue"
        width="fill"
        :show-hit-tab-to-complete="false"
        :style-overrides="{
          smallInputPaddingTop: 'extraSmall',
          smallInputPaddingBottom: 'extraSmall',
        }"
        run-initial-search
        include-value-type="string"
        is-async
        :source-url="pageSearchUrl"
        size="small"
        item-value-key="value"
        item-label-key="label"
        @item-selected="internalLinkValue = $event.value"
      />
      <iTextInput
        v-if="internalLinkType === LinkType.LINK_TYPE_HASHTAG"
        v-model="internalLinkValue"
        size="small"
        placeholder="Enter Hashtag"
        width="fill"
      />
      <StudioAutoComplete
        v-if="internalLinkType === LinkType.LINK_TYPE_STORY"
        :model-value="internalLinkValue"
        width="fill"
        :show-hit-tab-to-complete="false"
        :style-overrides="{
          smallInputPaddingTop: 'extraSmall',
          smallInputPaddingBottom: 'extraSmall',
        }"
        is-async
        run-initial-search
        :source-url="storySearchUrl"
        size="small"
        item-value-key="value"
        item-label-key="label"
        @item-selected="internalLinkValue = $event.value"
      />
      <iTextInput
        v-if="internalLinkType === LinkType.LINK_TYPE_HYPERLINK"
        v-model="internalLinkValue"
        size="small"
        placeholder="Enter Url"
        width="fill"
      />
      <iText v-if="showInvalidUrlMessage" variant="error">
        Invalid url
      </iText>
    </iColumn>
    <iToggleSwitch
      v-model="internalOpenInNewTab"
      label="Open in new tab"
      size="small"
    />
  </iColumn>
</template>

<script>
import StudioAutoComplete from "%/dynamic-component-editor/components/StudioAutoComplete.vue";
import LinkType from "%/dynamic-component-editor/options/link-type";
import { mapState } from "pinia";
import { useGeneralStore } from "%/dynamic-component-editor/stores/general-store";
import { richTextToolRegistry } from "@vcl";

export default {
  name: "DestinationPicker",
  components: { StudioAutoComplete },
  props: {
    publicationId: {
      type: Number,
      required: true,
    },
    linkValue: {
      type: String,
      required: false,
      default: "",
    },
    linkText: {
      type: String,
      required: false,
      default: "",
    },
    linkType: {
      type: String,
      required: false,
      default: "",
    },
    openInNewTab: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  emits: ["update", "invalid-url"],
  data() {
    return {
      internalLinkType: this.linkType,
      internalLinkValue: this.linkValue,
      internalLinkText: this.linkText,
      internalOpenInNewTab: this.openInNewTab,
      isValidHyperlink: false,
      LinkType,
    };
  },
  computed: {
    ...mapState(useGeneralStore, ["apiV1"]),
    pageSearchUrl() {
      return this.apiV1 + `/publication/${this.publicationId}/pages/autocomplete`;
    },
    storySearchUrl() {
      return this.apiV1 + `/publication/${this.publicationId}/stories/autocomplete`;
    },
    valueToEmit() {
      return {
        linkText: this.internalLinkText,
        linkValue: this.internalLinkValue,
        linkType: this.internalLinkType,
        openInNewTab: this.internalOpenInNewTab,
      };
    },
    showInvalidUrlMessage() {
      return this.internalLinkType === LinkType.LINK_TYPE_HYPERLINK
        && Boolean(this.internalLinkValue)
        && !this.isValidHyperlink;
    },
  },
  watch: {
    valueToEmit(value) {
      if (!this.validateHref(value.linkType, value.linkValue)) {
        return;
      }

      this.$emit("update", value);
    },
    linkType() {
      this.internalLinkType = this.linkType;
    },
    linkValue() {
      this.internalLinkValue = this.linkValue;
    },
    linkText() {
      this.internalLinkText = this.linkText;
    },
    openInNewTab() {
      this.internalOpenInNewTab = this.openInNewTab;
    },
  },
  mounted() {
    this.validateHref(this.linkType, this.linkValue);
  },
  methods: {
    validateHref(linkType, linkValue) {
      if (linkType === LinkType.LINK_TYPE_HYPERLINK) {
        this.isValidHyperlink = richTextToolRegistry.linkTool.isValidUrl(linkValue);
        if (!this.isValidHyperlink) {
          this.$emit("invalid-url", true);
          return false;
        }
      }
      this.isValidHyperlink = true;
      this.$emit("invalid-url", false);
      return true;
    },
  },
  styleGuide: () => ({}),
};
</script>

<style scoped lang="scss">

</style>
